export default __webpack_public_path__ + "static/media/Incoming_Call.e053c683.svg";